<template>
  <div
    class="
      test-view test-details-view
      past-test-student-view
      qiid-question-past-test
      past-std-view past-std-view-10-jan
      may-18-pr
    "
  >
    <div class="mobile-hide-breadcrumbs">
      <v-breadcrumbs>
        <template>
          <v-breadcrumbs-item>
            <span class="light-text">
              {{ currentQuestion.subject_name }} /
            </span>
          </v-breadcrumbs-item>
          <v-breadcrumbs-item>
            <span class="light-text"> {{ currentQuestion.chapterName }} /</span>
          </v-breadcrumbs-item>
          <v-breadcrumbs-item>
            <span class="light-text"> {{ currentQuestion.topicName }} </span>
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </div>
    <div class="test-page-section qiid-question-view">
    <div class="test-counter-block pasterrorblk show-mobile-panel">
      <div class="hamburger-outer">
        <div class="show-timer-UI">
          <div v-if="showTimerFlag" class="">
            <v-btn class="show-time-btn" @click="showTimer()">Show Timer</v-btn>
          </div>
          
          <div v-else-if="!showTimerFlag">
            <div class="show-time-btn jan-10-hide-btn">
              <div class="Average_Time">Average Time for Correct</div>
              <div
                :class="
                  avgTimeExceeded ? 'Average_Time_red' : ' Average_Time_green'
                "
              >
                {{ timeRemainingString }}
              </div>
              <div class="Average_hide" @click="hideTimer()">HIDE</div>
            </div>
          </div>
        </div>
        <div class="menu-icon-button-outer">
        <v-btn
            
            @click="showMenu()"
            icon
            class="mobile-shoe-menu"
            :disabled="currentQuestion.answerSubmitted"
        ><v-icon class="hamburger-menu">mdi-menu</v-icon>
            
        </v-btn>
        </div>
        </div>
        <div v-if="!currentQuestion.answerSubmitted && show" class="scroll-card-10-jan">
          <div class="side-card healt-data">
            <div>
              <div class="health-data-title">Health Data:</div>
              <div>
                <div class="progress-title">
                  Chapter: 
                  <span>{{ currentQuestion.chapterName }}</span>
                </div>
                <div class="subject-progress">
                  <v-progress-linear
                    :color="getColor(currentQuestion.chapterHealth)"
                    :height="25"
                    :value="currentQuestion.chapterHealth"
                    reactive
                  >
                    <div class="progressbar-content">
                      <div class="chapter-health-content">
                        <div>{{ currentQuestion.chapterHealth }}%</div>
                      </div>
                    </div>
                  </v-progress-linear>
                </div>
              </div>
              <div>
                <div class="progress-title">
                  Topic: 
                  <span>{{ currentQuestion.topicName }}</span>
                </div>
                <div class="subject-progress">
                  <v-progress-linear
                    :color="getColor(currentQuestion.topicHealth)"
                    :height="25"
                    :value="currentQuestion.topicHealth"
                    reactive
                  >
                    <div class="progressbar-content">
                      <div class="chapter-health-content">
                        <div>{{ currentQuestion.topicHealth }}%</div>
                      </div>
                    </div>
                  </v-progress-linear>
                </div>
              </div>
            </div>
          </div>
          <div class="side-card Question-Data">
            <div class="Question-Data-title">Question Data:</div>
            <div class="diff-title">
              Difficulty (Out of 6):
              <span>{{ currentQuestion.difficulty }}</span>
            </div>
            <div class="diff-title">
              Key Skill:
              <span>{{ currentQuestion.key_skill }}</span>
            </div>
            <div class="diff-title">
              %Correct: <span>{{ currentQuestion.correct_percentage }}%</span>
            </div>
            <div class="diff-title">
              %Incorrect:
              <span>{{ currentQuestion.incorrect_percentage }}%</span>
            </div>
          </div>
          <div class="side-card jee-card">
            <div
              class="jee-card-row"
              v-for="tag in currentQuestion.taggedConcepts"
            >
              <div class="jee-btn">{{ tag.tag }}</div>
            </div>
          </div>
        </div>
        <div
          v-if="currentQuestion.answerSubmitted && (videoList && (videoList.mainConcept.length || videoList.subTopic.length))"
          class="inner-block scroll-card-11-jan"
        >
          <div class="number-contet video-cp3-20mar">
            <VideoList :videoList="videoList" :test_id="test_id" :question_id="this.currentQuestion.id"/>
          </div>
        </div>
        
      </div>
      <div class="test-btn-quection">
        <div class="report-error-btn">
          <v-btn
            :disabled="currentQuestion.isAnswered && !currentQuestion.answerSubmitted"
            color="primary"
            class="cust-btn right-align"
            @click="openReportErrorDialog"
            >Report Error
          </v-btn>
          <v-btn
            v-if="!this.bookmarkQuestion"
            :disabled="currentQuestion.isAnswered && !currentQuestion.answerSubmitted"
            color="primary"
            class="cust-btn right-align"
            @click="addBookmark()"
            >Bookmark Question
          </v-btn>
          <v-btn
            v-if="this.bookmarkQuestion"
            :disabled="currentQuestion.isAnswered && !currentQuestion.answerSubmitted"
            color="primary"
            class="cust-btn right-align"
            @click="removeBookmark()"
            >Remove Bookmark
          </v-btn>
        </div>
        <v-card class="mx-auto normal-card live-test-hg test-10-jan-card">
          <pinch-zoom
            class="pinch-zoom"
            disableZoomControl="disable"
            :wheel="false"
          >
            <div class="tst-quection-block" ref="questionBox">
              <div class="practice-session-answer">
                <div>
                  <Comprehension
                    :showAnswerField="true"
                    :currentQuestion="currentQuestion"
                    v-if="
                      (QUE_TYPES &&
                        currentQuestion.question_type ==
                          QUE_TYPES.COMPREHENSION) ||
                        (QUE_TYPES &&
                          currentQuestion.question_type == QUE_TYPES.TC)
                    "
                  />
                  <SingleAnsQuePrivew
                    :showAnswerField="true"
                    :currentQuestion="currentQuestion"
                    :practiceSessionView="practiceSessionView"
                    v-if="
                      (QUE_TYPES &&
                        currentQuestion.question_type ==
                          QUE_TYPES.SINGLE_CORRECT) ||
                        (QUE_TYPES &&
                          currentQuestion.question_type ==
                            QUE_TYPES.SINGLE_CORRECT_SEC2) ||
                        (QUE_TYPES &&
                          currentQuestion.question_type ==
                            QUE_TYPES.ASSERTION_REASON)
                    "
                  />
                  <MultipleCorrectPrivew
                    :showAnswerField="true"
                    :currentQuestion="currentQuestion"
                    :practiceSessionView="practiceSessionView"
                    v-if="
                      QUE_TYPES &&
                        currentQuestion.question_type ==
                          QUE_TYPES.MULTIPLE_CORRECT
                    "
                  />
                  <IntegerPrivew
                    :showAnswerField="true"
                    :currentQuestion="currentQuestion"
                    :practiceSessionView="practiceSessionView"
                    v-if="
                      QUE_TYPES &&
                        currentQuestion.question_type == QUE_TYPES.INTEGER
                    "
                  />
                  <SubjectivePrivew
                    :showAnswerField="true"
                    :inputColour="inputColour"
                    :currentQuestion="currentQuestion"
                    :practiceSessionView="practiceSessionView"
                    v-if="
                      QUE_TYPES && 
                        (currentQuestion.question_type == QUE_TYPES.SUBJECTIVE || currentQuestion.question_type == QUE_TYPES.SUBJECTIVEINTEGER)
                    "
                  />
                  <MatrixMatchPrivew
                    :showAnswerField="true"
                    :currentQuestion="currentQuestion"
                    :practiceSessionView="practiceSessionView"
                    v-if="
                      QUE_TYPES &&
                        currentQuestion.question_type == QUE_TYPES.MATRIX_MATCH
                    "
                  />

                  <MatrixMatchOptionPrivew
                    :showAnswerField="true"
                    :currentQuestion="currentQuestion"
                    :practiceSessionView="practiceSessionView"
                    v-if="
                      QUE_TYPES &&
                        currentQuestion.question_type ==
                          QUE_TYPES.MATRIX_MATCH_OPTION
                    "
                  />
                </div>
              </div>
            </div>
          </pinch-zoom>
        </v-card>
      </div>
      <div class="test-counter-block pasterrorblk show-desktop-panel">
        <div v-if="!alertBoxData.outOfQuestions"class="show-timer-UI">
          <div v-if="showTimerFlag" class="">
            <v-btn class="show-time-btn" @click="showTimer()">Show Timer</v-btn>
          </div>
          <div v-else-if="!showTimerFlag">
            <v-btn class="show-time-btn jan-10-hide-btn">
              <div class="Average_Time">Average Time for Correct</div>
              <div
                :class="
                  avgTimeExceeded ? 'Average_Time_red' : ' Average_Time_green'
                "
              >
                {{ timeRemainingString }}
              </div>
              <div class="Average_hide" @click="hideTimer()">HIDE</div>
            </v-btn>
          </div>
        </div>
        <div v-if="alertBoxData.outOfQuestions" class="show-timer-UI">
          <div v-if="showTimerFlag" class="">
            <v-btn disabled class="show-time-btn" @click="showTimer()">Show Timer</v-btn>
          </div>
          <div v-else-if="!showTimerFlag">
            <div class="show-time-btn jan-10-hide-btn">
              <div class="Average_Time">Average Time for Correct</div>
              <div
                :class="
                  avgTimeExceeded ? 'Average_Time_red' : ' Average_Time_green'
                "
              >
                {{ timeRemainingString }}
              </div>
              <div class="Average_hide" @click="hideTimer()">HIDE</div>
            </div>
          </div>
        </div>
        <div v-if="!currentQuestion.answerSubmitted" class="scroll-card-10-jan">
          <div class="side-card healt-data">
            <div>
              <div class="health-data-title">Health Data:</div>
              <div>
                <v-tooltip left  bottom content-class="cust-new-tooltip-top open-top">
									<template  v-slot:activator="{ on }">
                    <v-hover v-model="buttonHovering">
                      <span
                        v-on="on"
                        class="progress-title single-line"
                        depressed
                        :class="{                            
                          'text-transform-none': true,
                          'btn-center': true,
                          'btn-default': true,
                        }"
											>Chapter: 
                      <span>{{currentQuestion.chapterName}}</span>
                      </span>
                    </v-hover>
											
									</template>
								  <span class="progress-title" >Chapter: {{ currentQuestion.chapterName }}</span>
							  </v-tooltip>
                <div class="subject-progress">
                  <v-progress-linear
                    :color="getColor(currentQuestion.chapterHealth)"
                    :height="25"
                    :value="currentQuestion.chapterHealth"
                    reactive
                  >
                    <div class="progressbar-content">
                      <div class="chapter-health-content">
                        <div>{{ currentQuestion.chapterHealth }}%</div>
                      </div>
                    </div>
                  </v-progress-linear>
                </div>
              </div>
              <div>
                <v-tooltip left  bottom content-class="cust-new-tooltip-top open-top">
									<template  v-slot:activator="{ on }">
                    <v-hover v-model="buttonHovering">
                      <span
                        v-on="on"
                        class="progress-title single-line"
                        depressed
                        :class="{                            
                          'text-transform-none': true,
                          'btn-center': true,
                          'btn-default': true,
                        }"
											>Topic: 
                      <span>{{ currentQuestion.topicName }}</span>
                      </span>
                    </v-hover>
											
									</template>
								  <span class="progress-title" >Topic: {{ currentQuestion.topicName }}</span>
							  </v-tooltip>
                <div class="subject-progress">
                  <v-progress-linear
                    :color="getColor(currentQuestion.topicHealth)"
                    :height="25"
                    :value="currentQuestion.topicHealth"
                    reactive
                  >
                    <div class="progressbar-content">
                      <div class="chapter-health-content">
                        <div>{{ currentQuestion.topicHealth }}%</div>
                      </div>
                    </div>
                  </v-progress-linear>
                </div>
              </div>
            </div>
          </div>
          <div class="side-card Question-Data">
            <div class="Question-Data-title">Question Data:</div>
            <div class="diff-title">
              Difficulty (Out of 6):
              <span>{{ currentQuestion.difficulty }}</span>
            </div>
            <div class="diff-title">
              Key Skill:
              <span>{{ currentQuestion.key_skill }}</span>
            </div>
            <div class="diff-title">
              %Correct: <span>{{ currentQuestion.correct_percentage }}%</span>
            </div>
            <div class="diff-title">
              %Incorrect:
              <span>{{ currentQuestion.incorrect_percentage }}%</span>
            </div>
          </div>
          <div class="side-card jee-card tagboxheight-11feb">
            <div
              class="jee-card-row"
              v-for="tag in currentQuestion.taggedConcepts"
            >
              <div class="jee-btn">{{ tag.tag }}</div>
            </div>
          </div>
        </div>
        <div
          v-if="currentQuestion.answerSubmitted"
          class="inner-block scroll-card-11-jan"
        >
          <div class="number-contet video-cp3-20mar">
            <VideoList :videoList="videoList" :test_id="test_id" :question_id="this.currentQuestion.id"/>
          </div>
        </div>
       
      </div>
    </div>
    <div class="test-bottom logo-btm hint-btn-group jan-10-practice">
      <div class="hint-outer-block">
        <div
          class="test-btn-block-answering"
          v-for="(hint, hintIndex) in currentQuestion.hints"
          :key="hint.id"
        >
          <v-btn
            v-if="!currentQuestion.isPreview && !currentQuestion.isAnswered"
            text
            class="primary-new-btn"
            @click="hintFunction(hintIndex)"
          >Hint {{ hintIndex + 1 }}
          </v-btn>
          </div>
          <div class="mobile-hide-breadcrumbs">
          <v-btn
            v-if="currentQuestion.isAnswered && !alertBoxData.outOfQuestions && !currentQuestion.answerSubmitted && !currentQuestion.isPreview"
            class="right-btn cust-btn practice-session-btns clear-session-btn-color"
            color="primary"
            @click="onClearResponse()"
            >Clear Response
          </v-btn>
          </div>
        
      </div>
      <div class="soluction-reponse-btn">
        <div class="btn-10-jan mobile-hide-breadcrumbs">
          <v-btn
            v-if="!currentQuestion.isPreview && !currentQuestion.isAnswered"
            class="right-btn cust-btn practice-session-btns"
            color="primary"
            @click="onShowSolution()"
            >Show Solution
          </v-btn>
        </div>
        <div :class="{ 'btn-margin0 show-mobile-panel':currentQuestion.answerSubmitted || currentQuestion.isPreview ,'btn-10-jan show-mobile-panel':!currentQuestion.answerSubmitted && !currentQuestion.isPreview }">
          <v-btn
            v-if="!currentQuestion.isPreview && !alertBoxData.outOfQuestions && !currentQuestion.isAnswerDisabled"
            class="right-btn cust-btn practice-session-btns submit-ps-btn"
            color="primary"
            :loading="loading"
            @click="submitAction()"
            >Submit
          </v-btn>
        </div>
        <div class="btn-10-jan show-mobile-panel">
          <v-btn
            v-if="currentQuestion.isAnswered && !alertBoxData.outOfQuestions && !currentQuestion.answerSubmitted && !currentQuestion.isPreview"
            class="right-btn cust-btn practice-session-btns clear-session-btn-color"
            color="primary"
            @click="onClearResponse()"
            >Clear Response
          </v-btn>
        </div>
        <div class="btn-10-jan">
          <v-btn
            v-if="!currentQuestion.isAnswered || currentQuestion.isPreview || currentQuestion.answerSubmitted"
            class="right-btn cust-btn practice-session-btns"
            color="primary"
            :loading="loading"
            :disabled="disableNext"
            @click="onClickNextQuestion()"
            >Next Question
          </v-btn>
        </div>
       <div :class="{ 'btn-margin0 mobile-hide-breadcrumbs':currentQuestion.answerSubmitted || currentQuestion.isPreview ,'btn-10-jan mobile-hide-breadcrumbs':!currentQuestion.answerSubmitted && !currentQuestion.isPreview }">
          <v-btn
            v-if="!currentQuestion.isPreview && !alertBoxData.outOfQuestions && !currentQuestion.isAnswerDisabled"
            class="right-btn cust-btn practice-session-btns submit-ps-btn"
            color="primary"
            :loading="loading"
            @click="submitAction()"
            >Submit
          </v-btn>
        </div>
        <div class="btn-10-jan show-mobile-panel">
          <v-btn
            v-if="!currentQuestion.isPreview && !currentQuestion.isAnswered"
            class="right-btn cust-btn practice-session-btns"
            color="primary"
            @click="onShowSolution()"
            >Show Solution
          </v-btn>
        </div>
      </div>
    </div>
     <div class="finish-test-btn jan-10-finish-btn finish-4-may show-desktop-panel">
          <v-btn
            color="default"
            class="cust-btn finish-test"
            @click="onClickEndSession()"
            >End Session</v-btn
          >
        </div>
    <div class="show-mobile-panel">
      <div class="finish-test-btn jan-10-finish-btn">
          <v-btn
            color="default"
            class="cust-btn finish-test margin-top-10-button"
            @click="onClickEndSession()"
            >End Session</v-btn>
      </div>
    </div>
    <AlertBox
      :width="modalWidth"
      :onClose="onClose"
      :component="cComponent"
      :status="status"
      :data="alertBoxData"
    />
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import * as youtubeSearch from "youtube-search";
import ProgressBar from "@/components/common/ProgressBar.vue";
import moment from "moment";
import momentDuration from "moment-duration-format";
import SmoothScroll from 'smoothscroll-polyfill';
import { showUpgradeModal } from "@/utils/upgradeUtils";
let sessionTimerInterval = null;
momentDuration(moment);

import { mapActions, mapState, mapMutations, mapGetters } from "vuex";

import QuestionPallet from "@/components/PreviewTest/QuestionPallet.vue";
import MiniQuestionPallet from "@/components/PreviewTest/MiniQuestionPallet.vue";
import LegendsPastTest from "@/components/PreviewTest/LegendsPastTest.vue";
import LegendsOnHover from "@/components/PreviewTest/LegendsOnHover.vue";
import Comprehension from "@/components/PreviewTest/Comprehension.vue";
import SingleAnsQuePrivew from "@/components/PreviewTest/SingleAnsQuePrivew.vue";
import MultipleCorrectPrivew from "@/components/PreviewTest/MultipleCorrectPrivew.vue";
import IntegerPrivew from "@/components/PreviewTest/IntegerPrivew.vue";
import SubjectivePrivew from "@/components/PreviewTest/SubjectivePrivew.vue";
import AssertionReasonPrivew from "@/components/PreviewTest/AssertionReasonPrivew.vue";
import MatrixMatchOptionPrivew from "@/components/PreviewTest/MatrixMatchOptionPrivew.vue";
import MatrixMatchPrivew from "@/components/PreviewTest/MatrixMatchPrivew.vue";
import ChaptersHealth from "../../../views/pages/health/ChaptersHealth.vue";
import constants from "@/utils/constants.js";
import TestResultsVue from "../ResultAnalysis/TestResults.vue";
import VideoList from "@/components/common/VideoList.vue";

export default {
  name: "PracticeSessionQuestionView",
  components: {
    QuestionPallet,
    MiniQuestionPallet,
    LegendsPastTest,
    LegendsOnHover,
    Comprehension,
    SingleAnsQuePrivew,
    MultipleCorrectPrivew,
    IntegerPrivew,
    SubjectivePrivew,
    AssertionReasonPrivew,
    MatrixMatchOptionPrivew,
    MatrixMatchPrivew,

    Carousel,
    Slide,
    ProgressBar,
    VideoList,
    ChaptersHealth,
  },
  mounted() {
    this.scrollToElement();
    SmoothScroll.polyfill();
    this.questionTypes = this.QUE_TYPES;
    this.questionStatus = this.QUESTION_STATUS;
    this.questionStatusColor = this.QUESTION_STATUS_COLOR;
    this.setIsPastTest(false);
    if (
      this.$route.params.practice_session_id ||
      this.$route.params.improvement_assign_id
    ) {
      this.test_id = this.$route.params.test_id
        ? this.$route.params.test_id
        : this.$route.params.improvement_assign_id;
      this.getQuestion(this.QUESTION_ACTIONS.START_SESSION);
    }
  },
  data() {
    return {
      isTestCustom: false,
      isShowReportErrorBtn: true,
      modalWidth: null,
      instructionsTooltip: null,
      cComponent: "components/coordinator/Questionadd",
      alertBoxData: {outOfQuestions: false},
      status: false,
      testDetails: null,
      questionTypes: this.QUE_TYPES,
      questionStatus: this.QUESTION_STATUS,
      questionStatusColor: this.QUESTION_STATUS_COLOR,
      questionData: {},
      questions: [],
      currentQuestion: {},
      questionNumber: null,
      instructions: "",
      scrollPerPage: false,
      direction: "",
      subTopicName: "",
      practiceSessionView: true,
      selectedSubject: "",
      bookmarkQuestion: false,
      showTimerFlag: false,
      difficulty: constants.DIFFICULTY_LEVELS,
      countDown: null,
      test_id: null,
      onSubmitResponse: {},
      practice_session_id: null,
      totalSessionDuration: null,
      sessionTimerSign: "",
      avgTimeExceeded: false,
      isShowHintPopUp: true, 
      timeRemainingString: null,
      disableAnswering: false,
      disableReportOrBookmark: false,
      videoList: {
        taggedConcepts: [],
        mainConcept: [],
        subTopic: [],
      },
      disableNext: false,
      loading: false,
      endCustomSession: false,
      buttonHovering: false,
      show:false,
      inputAnswer:'',
      inputColour:'',
      onNextQuestion:false
    };
  },
  computed: {
    ...mapState("userStore", ["user"]),
  },
  watch: {
    "$route.params": function(val) {
      if (val) {
        this.practice_session_id = this.$route.params.ps_id;
        this.test_id = this.$route.params.test_id;
        this.getQuestion(this.QUESTION_ACTIONS.START_SESSION);
      }
    },
    buttonHovering (val) {
        this.showToolTip = val;
    },
  },
  beforeDestroy() {
    clearInterval(sessionTimerInterval);
    localStorage.removeItem("previousPath");
    },
  methods: {
    ...mapActions({
      setTestData: "testStore/setTestData",
      setSubjectQuestionTypeList: "testStore/setSubjectQuestionTypeList",
      setFilteredQuestionsList: "testStore/setFilteredQuestionsList",
      setSelectedSQTIndex: "testStore/setSelectedSQTIndex",
      setSelectedQuestionIndex: "testStore/setSelectedQuestionIndex",
      setQuestions: "questionStore/setQuestions",
      getTestForPracticeSession: "testStore/getTestForPracticeSession",
      updateTestForPracticeSession: "testStore/updateTestForPracticeSession",
      addBookmarkQuestion: "testStore/addBookmarkQuestion",
      removeBookmarkQuestion: "testStore/removeBookmarkQuestion",
      setDisableSecondaryAction: "testStore/setDisableSecondaryAction",
      getQuestionOptions:"testStore/getQuestionOptions",
      getTestForImprovementAssignment:
        "testStore/getTestForImprovementAssignment",
      updateTestForImprovementAssignment:
        "testStore/updateTestForImprovementAssignment",
      saveEvent: "testStore/saveEvent",
    }),
    ...mapMutations("testStore", ["setIsPastTest"]),
    ...mapMutations("app", ["addBreadCrumbChilde"]),

    updateQuestionStatus(ansStatus) {
      let isAnswered = this.currentQuestion.answerSubmitted;
      if (ansStatus == this.QUESTION_ACTIONS.SUBMIT) {
        this.currentQuestion.answerSubmitted = true;
        this.removeLocalItem();
        this.endAction = this.QUESTION_ACTIONS.SUBMIT;
      } else if (ansStatus == this.QUESTION_ACTIONS.NEXT) {
        this.endAction = this.QUESTION_ACTIONS.NEXT;
        this.removeLocalItem();
      } else if (ansStatus == this.QUESTION_ACTIONS.END_TEST) {
        this.endAction = this.QUESTION_ACTIONS.END_TEST;
        clearInterval(sessionTimerInterval);
        this.removeLocalItem();
      } else if (ansStatus == this.QUESTION_ACTIONS.CLEAR) {
        this.endAction = this.QUESTION_ACTIONS.CLEAR;
      }
      this.saveCurrentAction(ansStatus);
    },
    getUpdateProgressPostData(type) {
      let postData = [
        {
          activity: this.QUESTION_ACTIVITY.STOP,
          entity: "",
          entity_id: 0,
        },
        {
          activity: this.QUESTION_ACTIVITY.START,
          entity: "",
          entity_id: 0,
        },
      ];
      if (
        type == this.QUESTION_ACTIONS.NEXT ||
        type == this.QUESTION_ACTIONS.START_SESSION
      ) {
        return [postData[1]];
      } else if (
        type == this.QUESTION_ACTIONS.SUBMIT ||
        type == this.QUESTION_ACTIONS.END_SESSION
      ) {
        return [postData[0]];
      } else if (type == this.QUESTION_ACTIONS.CLEAR) {
        return postData;
      } else if (type == this.QUESTION_ACTIONS.END_TEST) {
        return [postData[0]];
      }
    },
     getAnswerAsPerType(q) {
      let answer = null;
      let selectedOption = null;
      let options = null;
      let questionType =
        q.question_type == this.questionTypes.COMPREHENSION ||
        q.question_type == this.questionTypes.TC
          ? q.subtype
          : q.question_type;

      if (
        questionType == this.questionTypes.TC_2Q_SA ||
        questionType == this.questionTypes.TC_3Q_SA ||
        questionType == this.questionTypes.COMPREHENSION_3Q_SA ||
        questionType == this.questionTypes.COMPREHENSION_2Q_SA ||
        questionType == this.questionTypes.COMPREHENSION_2Q_MM
      ) {
        questionType = this.questionTypes.SINGLE_CORRECT;
      } else if (
        questionType == this.questionTypes.COMPREHENSION_3Q_MA ||
        questionType == this.questionTypes.COMPREHENSION_2Q_MA
      ) {
        questionType = this.questionTypes.MULTIPLE_CORRECT;
      }
      switch (questionType) {
        case this.questionTypes.INTEGER:
          answer = q.correct_answer;
          break;

        case this.questionTypes.MATRIX_MATCH:
          options = [];
          q.options_abc.map((o, idx) => {
            if (o.correct_answer > "") {
              options.push({
                option_id: o.id,
                value: o.correct_answer,
              });
            }
          });
          answer = options.length > 0 ? options : null;
          break;

        case this.questionTypes.MATRIX_MATCH_OPTION:
          selectedOption = q.options.find(
            (option) => option.correct_answer == true
          );
          answer = selectedOption ? { option_id: selectedOption.id } : null;
          break;

        case this.questionTypes.SUBJECTIVE:
        case this.questionTypes.SUBJECTIVEINTEGER:
        case this.questionTypes.COMPREHENSION_2Q_NU:
          answer = {};
          answer = q.correct_answer;
          break;

        case this.questionTypes.ASSERTION_REASON:
          selectedOption = q.options.find(
            (option) => option.correct_answer == true
          );
          answer = selectedOption ? { option_id: selectedOption.id } : null;
          break;

        case this.questionTypes.MULTIPLE_CORRECT:
          options = [];
          q.options.map((o, idx) => {
            if (o.correct_answer == true) {
              options.push(o.id);
            }
          });
          answer = options.length > 0 ? { option_id: options } : null;
          break;

        case this.questionTypes.SINGLE_CORRECT:
         case this.questionTypes.SINGLE_CORRECT_SEC2:
			   selectedOption = q.options.find(
            (option) => option.correct_answer == true
          );
          answer = selectedOption ? { option_id: selectedOption.id } : null;
          break;
      }
      return answer;
    },
    updateCurrentAction(questionStatus) {
      let selectedAnswer = null;
      let cq = this.currentQuestion;
      selectedAnswer = this.getAnswerAsPerType(cq);
      let callApi = false;
      let postData = this.getUpdateProgressPostData(questionStatus);
      let p1 = postData[0];
      let p2 = null;
      let defaultActions = [
        this.QUESTION_ACTIONS.NEXT,
        this.QUESTION_ACTIONS.START_SESSION,
      ];
      if (defaultActions.includes(questionStatus) && cq.id) {
        if (cq) {
          callApi = true;
          p1.activity = this.QUESTION_ACTIVITY.START;
          p1.entity = this.QUESTION_ENTITY.QUESTION;
          p1.index = 0;
          p1.test_detail_id = cq.test_detail_id + "";
          p1.entity_id = cq.id + "";
          p1.section_id = 1;
        }
      } else if (questionStatus == this.QUESTION_ACTIONS.SUBMIT) {
        this.currentQuestion.isAnswerDisabled = true;
          callApi = true;
          p1.activity = this.QUESTION_ACTIVITY.STOP;
          p1.entity = this.QUESTION_ENTITY.QUESTION;
          p1.entity_id = cq.id + "";
          (p1.index = 0), (p1.test_detail_id = cq.test_detail_id + "");
          p1.section_id = 1;
          p1.end_action = cq && selectedAnswer !==null ? this.endAction : null;;
          p1.answer = {
            status: 3,
            answer: selectedAnswer
          };
      } else if (questionStatus == this.QUESTION_ACTIONS.CLEAR) {
        if (cq) {
          callApi = true;
          postData.push(_.cloneDeep(p1));
          postData.push(_.cloneDeep(p1));
          p2 = postData[1];
          let p3 = postData[2];
          let p4 = postData[3];

          p1.activity = this.QUESTION_ACTIVITY.STOP;
          p1.entity = this.QUESTION_ENTITY.QUESTION;
          p1.index = 0;
          p1.test_detail_id = cq.test_detail_id + "";
          p1.entity_id = cq.id + "";
          p1.section_id = 2;
          p1.end_action = this.endAction;
          p1.answer = {
            status: 1,
            answer: selectedAnswer
          };

          p2.activity = this.QUESTION_ACTIVITY.START;
          p2.entity = this.QUESTION_ENTITY.QUESTION;
          p2.index = 0;
          p2.test_detail_id = cq.test_detail_id + "";
          p2.entity_id = cq.id + "";
          p2.section_id = 2;
          p2.end_action = this.endAction;
          p2.answer = {
            status: 1,
            answer: null,
          };

          p3.activity = this.QUESTION_ACTIVITY.STOP;
          p3.entity = this.QUESTION_ENTITY.QUESTION;
          p3.index = 0;
          p3.test_detail_id = cq.test_detail_id + "";
          p3.entity_id = cq.id + "";
          p3.section_id = 2;
          p3.end_action = this.endAction;

          p4.activity = this.QUESTION_ACTIVITY.START;
          p4.entity = this.QUESTION_ENTITY.QUESTION;
          p4.index = 0;
          p4.entity_id = cq.id + "";
          p4.test_detail_id = cq.test_detail_id + "";
          p4.section_id = 2;
        }
      } else if (questionStatus == this.QUESTION_ACTIONS.END_TEST) {
        callApi = true;
        p1.activity = this.QUESTION_ACTIVITY.STOP;
        p1.entity = this.QUESTION_ENTITY.TEST;
        p1.index = 0;
        p1.test_detail_id = cq.test_detail_id ? cq.test_detail_id : 0;
        p1.entity_id = this.test_id + "";
        p1.section_id = 2;
        p1.isAutoFinished = false;
        p1.end_action = this.endAction;
        p1.answer = {
          status: 4,
          answer: "",
        };
      }
      let reqData = {
        test_institute_id: null,
        test_schedule_id: null,
        actions: postData,
      };
      this.currentQuestion.user_selected_answer=JSON.stringify(p1.answer);
      this.scrollToElement();
      this.updateProgress(reqData, questionStatus);
    },
    updateProgress(reqData, questionStatus) {
      this.status = false;
      this.isShowHintPopUp = true;
      this.$root.showLoader = true;
      let fn;
      if (this.$route.name == "practice-session-question-view") {
        fn = "updateTestForPracticeSession";
      } else if (this.$route.name == "improvement-assignment-question-view") {
        fn = "updateTestForImprovementAssignment";
      }
      this[fn](reqData)
        .then((response) => {
          this.$root.showLoader = false;
          if (questionStatus == this.QUESTION_ACTIONS.CLEAR) {
            this.onClearResponse();
          } else if (
            questionStatus == this.QUESTION_ACTIONS.NEXT &&
            (this.currentQuestion.answerSubmitted || this.currentQuestion.isPreview)
          ) {
            this.getQuestion(this.QUESTION_ACTIONS.NEXT);
          }
          else if (questionStatus == this.QUESTION_ACTIONS.END_TEST) {
            clearInterval(sessionTimerInterval);
            this.removeLocalItem();
            let previousPath=localStorage.getItem("previousPath");
            if(previousPath){
            this.$router.replace({
                path: previousPath
            }).catch(() => {
                this.$router.replace({
                path: previousPath
            });
               });
            localStorage.removeItem("previousPath");
            }else{
                this.$router.back().catch(() => {});
            }
          } else if (questionStatus == this.QUESTION_ACTIONS.SUBMIT) {
            let health_change_on_practice =
              this.questionTopicHealth - response.topic_health;
              this.inputAnswer=response.attempt;
            if (response.attempt === "NA") {
              this.currentQuestion.answerSubmitted = true;
              this.alertBoxData = {
                noPSAnswer: true,
                question_average_time: response.question_average_time,
                question_time_spent: response.question_time_spent,
                topic_health: response.topic_health,
                topic_health_change: response.topic_health_change,
                health_change_on_practice: health_change_on_practice,
              };
              } else if (response.attempt == "C") {
              this.currentQuestion.answerSubmitted = true;
              this.alertBoxData = {
                correctPSAnswer: true,
                question_average_time: response.question_average_time,
                question_time_spent: response.question_time_spent,
                topic_health: response.topic_health,
                topic_health_change: response.topic_health_change,
                health_change_on_practice: health_change_on_practice,
              };
            } else if (response.attempt == "IC") {
              this.currentQuestion.answerSubmitted = true;
              this.alertBoxData = {
                incorrectPSAnswer: true,
                attempt: response.attempt,
                question_average_time: response.question_average_time,
                question_time_spent: response.question_time_spent,
                topic_health: response.topic_health,
                topic_health_change: response.topic_health_change,
                health_change_on_practice: health_change_on_practice,
              };
            } else if (
              response.attempt == "IC" &&
              this.countDown > response.question_average_time
            ) {
              this.currentQuestion.answerSubmitted = true;
              this.alertBoxData = {
                avgTimeOver: true,
                question_average_time: response.question_average_time,
                question_time_spent: response.question_time_spent,
                topic_health: response.topic_health,
                topic_health_change: response.topic_health_change,
                health_change_on_practice: health_change_on_practice,
              };
            }
            if (response.attempt) {
              this.modalWidth = "690px";
              this.status = true;
              this.cComponent =
                "components/student/Tests/PastTests/PracticeSessionPopUps";
              this.$forceUpdate();
            }
          }
          this.scrollToElement();
        })
        .catch((err) => {
          this.loading = false;
          this.$root.showLoader = false;
          if (questionStatus == this.QUESTION_ACTIONS.END_TEST) {
            let previousPath=localStorage.getItem("previousPath");
            if(previousPath){
            this.$router.replace({
                path: previousPath
            }).catch(() => {               
                this.$router.replace({
                path: previousPath
            });
               });
            localStorage.removeItem("previousPath");
            }else{
                this.$router.back().catch(() => {});
            }
          }
        });
    },
      submitPopup(){
      this.alertBoxData = {
          noPSAnswer: true,
        };
        this.modalWidth = "690px";
        this.status = true;
        this.cComponent =
          "components/student/Tests/PastTests/PracticeSessionPopUps";
        this.$forceUpdate();
    },
    submitAction(){
      this.currentQuestion.isAnswered ? this.updateQuestionStatus(this.QUESTION_ACTIONS.SUBMIT) : this.submitPopup();
    },
    onClickEndSession() {
      const sessionEndTime = moment();
      const sessionStartTime = moment(localStorage.getItem("session_start"));
      this.removeLocalItem();
      this.totalSessionDuration = sessionEndTime.diff(sessionStartTime);
      this.alertBoxData = {
        endSession: true,
        totalSessionDuration: this.convertMS(this.totalSessionDuration).time,
        endCustomSession: this.$route.name == "improvement-assignment-question-view" ? true : false,
        endRetryShortlisted: this.currentQuestion.is_retry_shortlisted,
      };
      this.modalWidth = "690px";
      this.status = true;
      this.cComponent =
        "components/student/Tests/PastTests/PracticeSessionPopUps";
      this.$forceUpdate();
    },
    onClickNextQuestion() {
      if(this.currentQuestion.answerSubmitted || this.currentQuestion.isPreview) {
        if(localStorage.getItem('showSolutionStart') != null) {
          let postData = 
            {
              event_name: "show-solution",
              start_time: localStorage.getItem('showSolutionStart'),
              test_id: this.test_id + "",
              question_id: this.currentQuestion.id,
            }
          this.saveEvent(postData);
        }
        if(localStorage.getItem('videoPlayTime') != null) {
          let postData= {
                event_name: "show-video",
                start_time: localStorage.getItem('videoPlayTime'),
                test_id: this.test_id + "",
                question_id: this.currentQuestion.id,
          }
          this.saveEvent(postData);
          this.removeLocalItem();
          localStorage.removeItem('showSolutionStart');
          localStorage.removeItem('videoPlayTime');
        }
        this.removeLocalItem();
        this.getQuestion(this.QUESTION_ACTIONS.NEXT);
      }
      else if(!this.currentQuestion.answerSubmitted) {
        this.alertBoxData = {
          noPSAnswer: true,
        };
        this.modalWidth = "690px";
        this.status = true;
        this.cComponent =
          "components/student/Tests/PastTests/PracticeSessionPopUps";
        this.$forceUpdate();
      }
    },
    scrollToTop() {
      let content = this.$refs.questionBox;
      content.scrollTop = 0;
      let scrollElem = document.getElementsByClassName("v-application--wrap");
      scrollElem[0].scrollIntoView();
    },
    openReportErrorDialog() {
      this.alertBoxData = {
        question: this.currentQuestion,
        errorDescription: "",
      };
      this.modalWidth = "1000px";
      this.status = true;
      this.cComponent = "components/student/Tests/PastTests/ReportError";
      this.$forceUpdate();
    },
    scrollToElement() {  
      if(this.show){
        window.scrollTo(0,441);
      }
      else{
        window.scrollTo(0,0);
      }
  },
  showMenu(){
    this.show=!this.show;
    window.scrollTo(0,0);
  },
    hintFunction(index) {
      this.isShowHintPopUp = false;
      this.alertBoxData = {
        hintNo: index + 1,
        hintText: this.currentQuestion.hintsList[index].hint,
      };
      this.modalWidth = "1000px";
      this.status = true;
      this.cComponent = "components/student/Tests/PastTests/Hint";
      this.$forceUpdate();
    },
    onClose(data) {
      // Handle upgrade confirmation modal response
      if (data.openPaymentModal) {
        this.cComponent = 'components/student/UpgradeToGold/GstChargesPopUp';
        this.modalWidth = '500px';
        this.status = true;
        this.alertBoxData = data.paymentData;
        return;
      }
      
      if (data.callNextQuestion) {
        if(this.currentQuestion.isPreview && (localStorage.getItem('showSolutionStart') != null)){
          localStorage.getItem('showSolutionStart');
          let postData = {
            event_name: "show-solution",
            start_time: localStorage.getItem('showSolutionStart'),
            test_id: this.test_id + "",
            question_id: this.currentQuestion.id,
            }
          this.saveEvent(postData);
        }
        
        if(localStorage.getItem('videoPlayTime') != null) {
          let postData= {
            event_name: "show-video",
            start_time: localStorage.getItem('videoPlayTime'),
            test_id: this.test_id + "",
            question_id: this.currentQuestion.id,
          }
          this.saveEvent(postData);
        }
          localStorage.removeItem('showSolutionStart');
          localStorage.removeItem('videoPlayTime');
          this.onNextQuestion=true;
        this.removeLocalItem();
        this.getQuestion(this.QUESTION_ACTIONS.NEXT);
      }
      if (data.showSolution) {
        this.inputColour=this.inputAnswer==constants.USER_ATTEMPT_STATUS.IC ? 'red': this.inputAnswer==constants.USER_ATTEMPT_STATUS.C ? 'green' : '';
        let reqData = {
          question_id:this.currentQuestion.id
          };
        this.getQuestionOptions(reqData)
        .then((response) => {
          this.currentQuestion.options=response;
          this.currentQuestion.isAttemptingTest = false;
          this.currentQuestion=this.generateQuestionObject(this.currentQuestion.question_type, this.currentQuestion,true);
          this.currentQuestion.isShowSolution = true                                     
        })
        .catch((err) => {
          
        });
        this.currentQuestion.isPreview = true;
        this.currentQuestion.isAnswerDisabled = true;
        setTimeout(() => {
          this.scrollToTop();
          this.renderMath();
        }, 30);
        let showSolutionStart = moment().format().toLocaleString();
        localStorage.setItem('showSolutionStart',showSolutionStart);
      }
      if (data.endSession) {
        if(this.currentQuestion.isPreview){
          let postData = 
            {
              event_name: "show-solution",
              start_time: localStorage.getItem('showSolutionStart'),
              test_id: this.test_id + "",
              question_id: this.currentQuestion.id,
            }
          this.saveEvent(postData);
          localStorage.removeItem('showSolutionStart');
        }
        if(localStorage.getItem('videoPlayTime') != null) {
            let postData= {
                event_name: "show-video",
                start_time: localStorage.getItem('videoPlayTime'),
                test_id: this.test_id + "",
                question_id: this.currentQuestion.id,
            }
          this.saveEvent(postData);
          localStorage.removeItem('videoPlayTime');
        }
        this.updateQuestionStatus(this.QUESTION_ACTIONS.END_TEST);
      }
      this.status = data.status;
    },
    getQuestion(questionAction) {
      this.inputAnswer='';
      this.inputColour='';
      this.$root.showLoader = true;
      this.loading = true;
      if(!localStorage.getItem('question')){
        if (this.$route.name == "practice-session-question-view") {
          let reqData = {
            practice_session_id: this.$route.params.practice_session_id,
            subject_id: this.$route.params.subject_id,
          };
          this.getTestForPracticeSession(reqData)
            .then((response) => {
              this.currentQuestion = this.processQuestion(response);
              localStorage.setItem('question', JSON.stringify(this.currentQuestion));
              this.questionNumber = response.question.list[0].question_number;
              // this.questionTopicHealth =
              //   response.health.list[0].children[0].children[0].health;
              questionAction =
                this.QUESTION_ACTIONS.NEXT == questionAction
                  ? this.QUESTION_ACTIONS.START_SESSION
                  : questionAction;
              this.updateCurrentAction(questionAction);
              this.startTimer(response.question.list[0].time || 1);
              setTimeout(() => {
                this.renderMath();
              }, 100); //practice_session question render issue
              this.$root.showLoader = false;
              this.loading = false;
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
              this.$root.showLoader = false;
              if(err.data.errors[0].code === "ERR0107" && this.$route.params.topicsSelected){
                this.alertBoxData = {
                  thatsAll: true,
                  errorMessage:err.data.errors[0].message 
                };
                this.disableNext = true;
                this.modalWidth = "690px";
                this.status = true;
                this.cComponent =
                  "components/student/Tests/PastTests/PracticeSessionPopUps";
                this.$forceUpdate();
              }
              //  else if (err.data.errors[0].code === "ERR0223") {
              //   this.alertBoxData = {
              //     errorMessage: err.data.errors[0].message,
              //     outOfQuestions: false,
              //     endCustomSession: this.$route.name == "dashboard/practice-session",
              //   };
              //   this.disableNext = true;
              //   this.modalWidth = "690px";
              //   this.onClickEndSession();
              // }
              else if(err.data.errors[0].code === "ERR0223"){
                this.showUpgradeConfirmationModal();
                return;
              }
              else if(err.data.errors[0].code === "ERR0107"){
                this.alertBoxData = {
                  errorMessage:err.data.errors[0].message, 
                  outOfQuestions: true,
                  endCustomSession: this.$route.name == "improvement-assignment-question-view" ? true : false,
                  endRetryShortlisted: this.currentQuestion.is_retry_shortlisted ? true : false,
                };
                this.disableNext = true;
                this.modalWidth = "690px";
                this.status = true;
                this.cComponent =
                  "components/student/Tests/PastTests/PracticeSessionPopUps";
                this.$forceUpdate();
              }
              this.loading = false;
              this.$root.showLoader = false;
            });
        } else if (this.$route.name == "improvement-assignment-question-view") {
          this.loading = true;
          let postData = {
            assignment_id: this.$route.params.improvement_assign_id,
            student_id: this.$route.params.student_id,
            question_number: localStorage.getItem("que_no")
              ? parseInt(localStorage.getItem("que_no")) + 1
              : 1,
          };
            this.getTestForImprovementAssignment(postData)
            .then((response) => {
              this.currentQuestion = this.processQuestion(response);
              localStorage.setItem('question', JSON.stringify(this.currentQuestion));
              this.questionNumber = response.question.list[0].question_number;
              localStorage.setItem("que_no", this.questionNumber);
              // this.questionTopicHealth =
              //   response.health.list[0].children[0].children[0].health;
              questionAction =
                this.QUESTION_ACTIONS.NEXT == questionAction
                  ? this.QUESTION_ACTIONS.START_SESSION
                  : questionAction;
              this.updateCurrentAction(questionAction);
              this.startTimer(response.question.list[0].time||1);
              this.$root.showLoader = false;
              this.loading = false;
            })
            .catch((err) => {
              this.$root.showLoader = false;
              this.loading = false;
              const sessionEndTime = moment();
              const sessionStartTime = moment(localStorage.getItem("session_start"));
              this.totalSessionDuration = sessionEndTime.diff(sessionStartTime);
              if(err.data && err.data.errors){
                if(err.data.errors[0].code === "ERR0115"){
                  this.alertBoxData = {
                  errorMessage:err.data.errors[0].message, 
                  outOfQuestions: true,
                  endCustomSession: this.$route.name == "improvement-assignment-question-view" ? true : false,
                  endRetryShortlisted: this.currentQuestion.is_retry_shortlisted ? true : false,
                  };
                 this.disableNext = true;
                 this.modalWidth = "690px";
                 this.status = true;
                 this.cComponent =
                  "components/student/Tests/PastTests/PracticeSessionPopUps";
                 this.$forceUpdate();
                }
                else if(err.data.errors[0].code === "ERR0223"){
                  this.showUpgradeConfirmationModal();
                  return;
                }
              }
              this.disableNext = true;
              this.loading = false;
              this.$root.showLoader = false;
            });
          }  
        }else{
            this.currentQuestion = JSON.parse(localStorage.getItem('question'));
            this.startTimer(localStorage.getItem('timeSeconds')||1);
            this.$root.showLoader = false;
            this.loading = false;
            this.avgTimeExceeded = localStorage.getItem('timerFlag') == 'true' ? false : true;
        }
        
    },
    startTimer(averageTime=0) {
      let updateTimeRemaining = true;
      if (averageTime > 0) {
        let timeObj = null;
        if(localStorage.getItem('timerFlag')!=null && this.onNextQuestion){
          localStorage.removeItem('timerFlag');
        }
        this.onNextQuestion=false;
        let isDecrementing = localStorage.getItem('timerFlag') ? localStorage.getItem('timerFlag') == 'true' : true;
        this.sessionTimerSign = '-';
        this.avgTimeExceeded = false;
        if (updateTimeRemaining) {
          timeObj = moment.duration(averageTime, "seconds");
        }
        if (sessionTimerInterval) {
          clearInterval(sessionTimerInterval);
        }
         this.timeRemainingString =
            this.sessionTimerSign + timeObj.format("mm:ss", { trim: false });
        sessionTimerInterval = setInterval(() => {
          if(isDecrementing){  this.sessionTimerSign = "-";}
          else if (!isDecrementing) { this.sessionTimerSign = "+";}
          if (isDecrementing && this.currentQuestion.answerSubmitted == false && !this.alertBoxData.outOfQuestions && !this.currentQuestion.isPreview) {
            this.avgTimeExceeded = false;
            timeObj.subtract(1, "seconds");
            localStorage.setItem('timerFlag',isDecrementing);
            localStorage.setItem('timeSeconds',timeObj.asSeconds());
          } else if (this.currentQuestion.answerSubmitted == false && !this.alertBoxData.outOfQuestions && !this.currentQuestion.isPreview){
            timeObj.add(1, "seconds");
            localStorage.setItem('timerFlag',isDecrementing);
            localStorage.setItem('timeSeconds',timeObj.asSeconds());
            this.sessionTimerSign = "+";
          }
          this.timeRemainingString =
            this.sessionTimerSign + timeObj.format("mm:ss", { trim: false });
          if (
            this.timeRemainingString == "00" ||
            (timeObj.hours() <= 0 &&
              timeObj.minutes() <= 0 &&
              timeObj.seconds() <= 0)
          ) {
            isDecrementing = false;
            this.avgTimeExceeded = true;
            if(this.isShowHintPopUp && this.currentQuestion.hints && this.currentQuestion.hints.length) {
              this.alertBoxData = {
                avgTimeOver: true,
              };
              this.modalWidth = "690px";
              this.status = true;
              this.cComponent =
                "components/student/Tests/PastTests/PracticeSessionPopUps";
              this.$forceUpdate();
            }
          }
        }, 1000);
      }
    },
    processQuestion(questionData) {
      this.bookmarkQuestion =
        questionData.question.list[0].question_bookmark == 1 ? true : false;
      let q = questionData.question.list[0];
      q.user_selected_answer =q.yourAnswer;
      let questionTypeId = q.question_type;
      questionTypeId =
        questionTypeId == this.QUE_TYPES.COMPREHENSION ||
        questionTypeId == this.QUE_TYPES.TC
            ? q.subtype.id ?q.subtype.id :q.subtype
          : q.question_type;
      let currentQuestion = {};
      currentQuestion = this.generateQuestionObject(questionTypeId, q);
        currentQuestion.subtype = q.subtype ? q.subtype.id ?q.subtype.id :q.subtype:'';
      if (
        q.question_type == this.QUE_TYPES.COMPREHENSION ||
        q.question_type == this.QUE_TYPES.TC
      ) {
        currentQuestion.passage = q.passage;
      }
      currentQuestion = this.getCurrentQuestionCommonKeys(currentQuestion, q);
      currentQuestion.id = q.id;
      currentQuestion.chapterName =
        q.datatype.title;
      currentQuestion.topicName = q.topic.title;
      currentQuestion.time = q.time;
      currentQuestion.time = null;
      let t = parseInt(q.time);
      this.countDown = t;

      currentQuestion.avgTime = q.time;
      currentQuestion.institute_id = q.institute_id;
      currentQuestion.difficulty = q.question_difficulty;
      currentQuestion.question_text = q.question_text;
      currentQuestion.section_id = questionData.testDetails.section_id;
      currentQuestion.test_id = questionData.testDetails.test_id;
      currentQuestion.correct_marks = questionData.testDetails.marks;
      currentQuestion.negative_marks = questionData.testDetails.negative_marks;
      currentQuestion.test_detail_id = questionData.testDetails.id;
      currentQuestion.subject_name = q.datatype.parentDetails.title
      this.selectedSubject = currentQuestion.subject_name;
      currentQuestion.chapterHealth =  q.datatype.health;
      currentQuestion.topicHealth =  q.topic.health;
      currentQuestion.correct_percentage =
        q.correct;
      currentQuestion.incorrect_percentage =
        q.incorrect;
      currentQuestion.is_retry_shortlisted = q.is_retry_shortlisted;
      this.questionTopicHealth = q.topic.health;
      let Temp = q.tags.map((x)=> {
						return{
							concept_id: x.concept_id,
              id: x.id,
              question_id: x.question_id,
              tag: x.tag.replace("#Tagged concept#", "")
						}
      }).filter(x => x.tag != "No Video");
      currentQuestion.taggedConcepts = Temp;
      currentQuestion.hintsList = q.hints;
      currentQuestion.isPreview = false;
      currentQuestion.disabled = false;
      currentQuestion.isAnswerDisabled = false;
      currentQuestion.answerSubmitted = false;
      this.currentQuestion = currentQuestion;
      this.currentQuestion.isAttemptingTest = true;
      this.getSubTopicVideos();
      this.getMainConceptVideos();
      this.getTaggedConceptVideos();
      return currentQuestion;
    },
    getVideos(noOfVideos, searchText) {
      return new Promise((resolve, reject) => {
        var opts = {
          maxResults: noOfVideos,
          key: this.YOUTUBE_SEARCH_API_KEY,
        };
        let searchTextt = this.selectedSubject + " " + searchText;
        youtubeSearch(searchTextt, opts, (err, results) => {
          if (err) {
            resolve(false);
          }
          resolve(results);
        });
      });
    },
    async getSubTopicVideos() {
      if (
        this.currentQuestion.subTopicName &&
        this.currentQuestion.subTopicName == "General"
      ) {
        return;
      }
      let subTopicName = this.currentQuestion.subTopicName
        ? this.currentQuestion.subTopicName.substr(
            this.currentQuestion.subTopicName.indexOf(".") + 1
          )
        : null;
      if (subTopicName) {
        let videos = await this.getVideos(4, subTopicName);
        this.videoList.subTopic = videos;
      }
    },
    async getTaggedConceptVideos() {
      let tc = [];
      if (
        this.currentQuestion.taggedConcepts &&
        this.currentQuestion.taggedConcepts.length
      ) {
        for (let i = 0; i < this.currentQuestion.taggedConcepts.length; i++) {
          const t = this.currentQuestion.taggedConcepts[i];
          if (t.tag != "No Video" && t.tag != "Source_Booklet") {
            let videos = await this.getVideos(
              2,
              t.tag.substr(t.tag.indexOf(".") + 1)
            );
            tc.push({
              tag: t.tag.substr(18),
              videos,
            });
          }
        }
      }
      if (tc && tc.length) {
        this.videoList.taggedConcepts = tc;
      }
    },
    async getMainConceptVideos() {
      if (
        this.currentQuestion.conceptName &&
        this.currentQuestion.conceptName == "General"
      ) {
        return;
      }
      let conceptName = this.currentQuestion.conceptName
        ? this.currentQuestion.conceptName.substr(
            this.currentQuestion.conceptName.indexOf(".") + 1
          )
        : null;
      if (conceptName) {
        let videos = await this.getVideos(2, conceptName);
        this.videoList.mainConcept = videos;
      }
    },
    getCurrentQuestionCommonKeys(currentQuestion, q) {
      currentQuestion.id = q.id;
      currentQuestion.questionNo = q.question_number;
      currentQuestion.question_text = q.question_text;
      currentQuestion.question_type = q.question_type;
      currentQuestion.questionType = { id: q.question_type };
      currentQuestion.parent_id = q.parent_id;
      currentQuestion.section_id = q.section_id;
      currentQuestion.test_detail_id = q.test_detail_id;
      currentQuestion.correct_marks = q.marks;
      currentQuestion.negative_marks = q.negative_marks;
      currentQuestion.partial_marking = q.partial_marking;
      currentQuestion.solution = q.solution;
      currentQuestion.hints = q.hints;
      currentQuestion.isBonus = q.is_bonus;
      currentQuestion.userSelectedAnswer = q.user_selected_answer;
      currentQuestion.status = this.QUESTION_STATUS.INITIAL;
      currentQuestion.isAnswered = false;
      currentQuestion.disabled = true;
      currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.NOT_ATTEMPTED;
      currentQuestion.institute_id = q.institute_id;
      currentQuestion.topic_id = q.topic_id;
      currentQuestion.subject_id = q.datatype.parent;
      currentQuestion.chapter_id = q.datatype.id;
      currentQuestion.subType = q.subtype;
      currentQuestion.key_skill = q.answertype.value ? q.answertype.value : "-";
      let om = q.obtained_mark ? q.obtained_mark : 0;
      currentQuestion.obtained_mark = om;
      let marks = q.marks;
      if (q.user_selected_answer) {
        let answer = q.user_selected_answer;
        currentQuestion.isAnswered = answer.answer ? true : false;
        currentQuestion.status = answer.status;
      }
      if (currentQuestion.institute_id == null) {
        this.isShowReportErrorBtn = false;
      }
      if (om == marks) {
        currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.CORRECT;
      } else if (om > 0 && om < marks) {
        currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.PARTIALLY_CORRECT;
      } else if (currentQuestion.isAnswered && om < 1) {
        currentQuestion.ansStatus = this.PAST_QUESTION_STATUS.INCORRECT;
      }
      return currentQuestion;
    },
    getCQRType1(type, q) {
      let responseData = {
        options: [],
        yourAnswer: "",
        correctAnswer: "",
      };
      let correctOptions = _.cloneDeep(q.options);
      let correctAnswer = [];
      let yourAnswer = [];
      let options = q.options.map((o) => {
        return { ...o, ...{ correct_answer: false } };
      });
      correctOptions.forEach((o) => {
        if (parseInt(o.correct_answer)) {
          correctAnswer.push(o.index);
        }
      });
      if (q.user_selected_answer) {
        let option = null;
        let answer = JSON.parse(q.user_selected_answer);
        if (answer.answer) {
          let switchType = 1;
          if (
            this.QUE_TYPES.ASSERTION_REASON == type ||
            this.QUE_TYPES.SINGLE_CORRECT == type ||
            this.QUE_TYPES.SINGLE_CORRECT_SEC2 == type ||
            this.QUE_TYPES.COMPREHENSION_2Q_SA == type ||
            this.QUE_TYPES.COMPREHENSION_2Q_MM == type ||
            this.QUE_TYPES.COMPREHENSION_3Q_SA == type ||
            this.QUE_TYPES.TC_2Q_SA == type ||
            this.QUE_TYPES.TC_3Q_SA == type
          ) {
            switchType = 1;
          } else {
            switchType = 2;
          }
          switch (switchType) {
            case 1:
              option = options.find((o) => o.id == answer.answer.option_id);
              if (option) {
                yourAnswer.push(option.index);
                option.correct_answer = true;
              }
              break;
            case 2:
              answer.answer.option_id.map((a) => {
                option = options.find((o) => o.id == a);
                if (option) {
                  yourAnswer.push(option.index);
                  option.correct_answer = true;
                }
              });
              break;
          }
        }
      }

      responseData.options = options;
      responseData.yourAnswer = yourAnswer.join(", ");
      responseData.correctAnswer = correctAnswer.join(", ");
      return responseData;
    },
    getCQRType2(q) {
      let responseData = {
        yourAnswer: "",
        correctAnswer: q.correct_answer.split("##"),
      };
      if (
        responseData.correctAnswer.length &&
        responseData.correctAnswer.length > 0
      ) {
        responseData.correctAnswer = responseData.correctAnswer.join(" - ");
      }
      if (q.user_selected_answer) {
        let answer = JSON.parse(q.user_selected_answer);
        let yourAnswer = answer.answer ? parseFloat(answer.answer) : null;
        responseData.yourAnswer = yourAnswer;
      }

      return responseData;
    },
    generateQuestionObject(typeId, q, isShowSolution=false) {
      let type = "";
      type = this.getQuestionType(typeId);
      let currentQuestion = {};
      if(!isShowSolution){
      currentQuestion = this.getCurrentQuestionCommonKeys(currentQuestion, q);
      }
      else{
        currentQuestion=q;
      }
      let cqr = null;
      switch (type) {
        case 1:
          cqr = this.getCQRType1(typeId, q);
          currentQuestion.options = cqr.options;
          currentQuestion.yourAnswer = cqr.yourAnswer;
          currentQuestion.correctAnswer = cqr.correctAnswer;
          break;
        case 2:
          cqr = this.getCQRType2(q);
          currentQuestion.correct_answer = cqr.yourAnswer;
          currentQuestion.yourAnswer = cqr.yourAnswer;
          currentQuestion.correctAnswer = cqr.correctAnswer;
          break;
        case 3:
          cqr = this.separateOptions(q, 1);
          currentQuestion.options_abc = cqr.options_abc;
          currentQuestion.options_pqr = cqr.options_pqr;
          currentQuestion.yourAnswer = cqr.yourAnswer;
          currentQuestion.correctAnswer = cqr.correctAnswer;

          break;
        case 4:
          cqr = this.separateOptions(q, 2);
          currentQuestion.options_abc = cqr.options_abc;
          currentQuestion.options_pqr = cqr.options_pqr;
          currentQuestion.options = cqr.op;
          currentQuestion.yourAnswer = cqr.yourAnswer;
          currentQuestion.correctAnswer = cqr.correctAnswer;

          break;
        case 6:
          cqr = this.getCQRType2(q);
          currentQuestion.correct_answer = cqr.yourAnswer;
          currentQuestion.yourAnswer = cqr.yourAnswer;
          currentQuestion.correctAnswer = cqr.correctAnswer;
          break;
      }
      return currentQuestion;
    },
    getQuestionType(id) {
      if (
        id == this.QUE_TYPES.ASSERTION_REASON ||
        id == this.QUE_TYPES.MULTIPLE_CORRECT ||
        id == this.QUE_TYPES.SINGLE_CORRECT ||
        id == this.QUE_TYPES.SINGLE_CORRECT_SEC2 ||
        id == this.QUE_TYPES.COMPREHENSION_2Q_SA ||
        id == this.QUE_TYPES.COMPREHENSION_2Q_MM ||
        id == this.QUE_TYPES.COMPREHENSION_2Q_MA ||
        id == this.QUE_TYPES.COMPREHENSION_3Q_SA ||
        id == this.QUE_TYPES.COMPREHENSION_3Q_MA ||
        id == this.QUE_TYPES.TC_2Q_SA ||
        id == this.QUE_TYPES.TC_3Q_SA
      ) {
        return 1;
      } else if (id == this.QUE_TYPES.INTEGER) {
        return 2;
      } else if (id == this.QUE_TYPES.MATRIX_MATCH) {
        return 3;
      } else if (id == this.QUE_TYPES.MATRIX_MATCH_OPTION) {
        return 4;
      } else if (
        id == this.QUE_TYPES.COMPREHENSION ||
        id == this.QUE_TYPES.TC
      ) {
        return 5;
      } else if (id == this.QUE_TYPES.SUBJECTIVE || id == this.questionTypes.COMPREHENSION_2Q_NU || id == this.questionTypes.SUBJECTIVEINTEGER) {
        return 6;
      }
    },
    separateOptions(q, type) {
      let options = q.options;
      let op = [];
      let options_abc = [];
      let options_pqr = [];

      let correctAnswer = [];
      let yourAnswer = [];

      options.forEach((option) => {
        if (option.column == 1) {
          option.correct_answer = option.correct_answer
            ? option.correct_answer
            : "";
          options_abc.push(option);
        } else if (option.column == 2) options_pqr.push(option);
        else {
          option.correct_answer = option.correct_answer
            ? option.correct_answer
            : false;
          op.push(option);
        }
      });

      // get correct answer
      if (type == 2) {
        // matrix match options
        op.forEach((o, idx) => {
          if (parseInt(o.correct_answer)) {
            correctAnswer.push(o.index);
            op[idx].correct_answer = false;
          }
        });
      }
      if (type == 1) {
        // matrix match
        options_abc.forEach((o, idx) => {
          if (o.correct_answer > "") {
            correctAnswer.push({
              index: o.index,
              value: o.correct_answer,
            });
            options_abc[idx].correct_answer = "";
          }
        });
      }

      if (type == 1) {
        // type = 1 : matrix match
        if (q.user_selected_answer) {
          let answer = JSON.parse(q.user_selected_answer);
          if (answer.answer) {
            answer.answer.map((a) => {
              let option = options_abc.find((o) => o.id == a.option_id);
              if (option) {
                yourAnswer.push({
                  index: option.index,
                  value: a.value,
                });
                option.correct_answer = a.value;
              }
            });
          }
        }
        let ya = yourAnswer.map((answer) => {
          let ans = answer.index + ": " + this.separateVals(answer.value);
          return ans;
        });
        ya = ya.join(" | ");
        let ca = correctAnswer.map((answer) => {
          let ans = answer.index + ": " + this.separateVals(answer.value);
          return ans;
        });
        ca = ca.join(" | ");
        yourAnswer = ya;
        correctAnswer = ca;
      } else if (type == 2) {
        // type = 2 : matrix match options
        if (q.user_selected_answer) {
          let answer = JSON.parse(q.user_selected_answer);
          if (answer.answer) {
            let option = op.find((o) => o.id == answer.answer.option_id);
            if (option) {
              yourAnswer.push(option.index);
              option.correct_answer = true;
            }
          }
        }
        yourAnswer = yourAnswer.join(", ");
        correctAnswer = correctAnswer.join(", ");
      }

      return {
        op,
        options_abc,
        options_pqr,
        yourAnswer,
        correctAnswer,
      };
    },
    getColor(percentage) {
      let color = "";

      if (percentage > 65) {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.GREEN;
      } else if (percentage > 19) {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.ORANGE;
      } else {
        color = this.STUDENT_HEALTH_PERCENTAGE_COLOR.RED;
      }
      return color;
    },
    hideTimer() {
      this.showTimerFlag = true;
    },
    showTimer() {
      this.showTimerFlag = false;
    },
    scrollToTop() {
      let scrollElem = document.getElementsByClassName("test-solution");
      if(window.innerWidth < 991){
        let currenttop=0;
        currenttop += scrollElem[0].offsetTop + 65;
        window.scrollTo({behavior: 'smooth', top: currenttop}); 
      }else{
      scrollElem[0].scrollIntoView({behavior: "smooth"});
      }
    },
    onShowSolution() {
      if(this.currentQuestion.isPreview && this.currentQuestion.answerSubmitted) {
        this.onClickNextQuestion();
      }
      else if(!this.currentQuestion.isPreview && !this.currentQuestion.answerSubmitted) {
        this.alertBoxData = {
          noPSAnswer: true,
        };
        this.modalWidth = "690px";
        this.status = true;
        this.cComponent =
          "components/student/Tests/PastTests/PracticeSessionPopUps";
        this.$forceUpdate();
      }
      else if(this.currentQuestion.answerSubmitted) {
        this.currentQuestion.isPreview = true;
        this.currentQuestion.isAnswerDisabled = true;
        setTimeout(() => {
                  this.scrollToTop();
              }, 30);
      }
    },
    parseTime(secs) {
      var minutes = Math.floor(parseFloat(secs) / 60);
      secs = Math.floor(secs > 0 ? secs : parseFloat(-secs) % 60);
      return `${minutes}:${secs}`;
    },
    processAlertBoxData(response) {
      if (response.attempt == "C" && response.topic_health_change >= 30) {
        this.alertBoxData = {
          increaseByThirty: true,
        };
      } else if (
        response.attempt == "C" &&
        response.topic_health_change >= 95
      ) {
        this.alertBoxData = {
          increaseByNinetyFive: true,
        };
      } else if (response.attempt == "C" && response.topic_health_change < 30) {
        this.alertBoxData = {
          increaseByThirty: true,
        };
      } else if (response.attempt == "C") {
        this.alertBoxData = {
          correctPSAnswer: true,
        };
      } else if (response.attempt == "IC") {
        this.alertBoxData = {
          incorrectPSAnswer: true,
        };
      } else if (response.attempt == "NA") {
        this.alertBoxData = {
          noPSAnswer: true,
        };
      }
    },
    async onClearResponse() {
      this.currentQuestion.isAnswered = false;

      let currentQuestionType = this.currentQuestion.question_type;
      if (
        currentQuestionType == this.QUE_TYPES.TC ||
        currentQuestionType == this.QUE_TYPES.COMPREHENSION
      ) {
        currentQuestionType = this.currentQuestion.subtype;
      }
      let type = await this.getQuestionType(currentQuestionType);
      this.scrollToTop();
      switch (type) {
        case 1:
          this.currentQuestion.options = this.currentQuestion.options.map(
            (opt) => {
              opt.correct_answer = false;
              return opt;
            }
          );
          break;
        case 2:
          this.currentQuestion.correct_answer = "";
          break;
        case 3:
          this.currentQuestion.options_abc = this.currentQuestion.options_abc.map(
            (opt) => {
              opt.correct_answer = "";
              return opt;
            }
          );
          break;
        case 4:
          this.currentQuestion.options = this.currentQuestion.options.map(
            (opt) => {
              opt.correct_answer = false;
              return opt;
            }
          );
          break;
        case 5:
          let subQuestions = this.currentQuestion.questions;
          subQuestions.forEach((sq) => {
            sq.options = sq.options.map((q) => {
              q.correct_answer = false;
              return q;
            });
          });
          break;
        case 6:
          this.currentQuestion.correct_answer = "";
          this.currentQuestion.startValue = null;
          this.currentQuestion.endValue = null;
          break;
      }
      this.setDisableSecondaryAction(false);
      this.scrollToElement();
    },
    saveCurrentAction(type) {
      this.updateCurrentAction(type);
    },
    addBookmark() {
      let reqData = {
        user_id: this.user.id,
        test_detail_id: this.currentQuestion.test_detail_id,
      };
      this.addBookmarkQuestion(reqData)
        .then((response) => {
          this.$toasted.success(`Question bookmark added successfully.`, {});
        })
        .catch((err) => {
          // this.$toasted.error(`Adding Bookmarked Question failed.`, {});
        });
      this.bookmarkQuestion = true;
    },
    removeBookmark() {
      let reqData = {
        user_id: this.user.id,
        test_detail_id: this.currentQuestion.test_detail_id,
      };

      this.removeBookmarkQuestion(reqData)
        .then((response) => {
          this.$toasted.success(`Question bookmark removed successfully.`, {});
        })
        .catch((err) => {
          this.$toasted.error(`Remove Bookmarked Question failed.`, {});
        });
      this.bookmarkQuestion = false;
    },
    removeLocalItem(){
      localStorage.removeItem('question');
      localStorage.removeItem('timerFlag');
      localStorage.removeItem('timeSeconds');
    },
    showUpgradeConfirmationModal() {
      showUpgradeModal(this);
    },
  },
};
</script>